import React from "react"
import { Box, Container, ResponsiveValue, Text } from "@chakra-ui/react"

import { SectionProps } from "@app/hoc/Section"
import { useContent } from "@hooks/useContent"

export type PageSummaryProps = GatsbyTypes.SanitySectionSummary & SectionProps

const Summary = ({ content, theme, innerRef, alignment }: PageSummaryProps) => {
  const { getContent } = useContent()
  const body = getContent({ content })

  const textAlign = (alignment?.toString() || "center") as ResponsiveValue<any>

  return (
    <Box ref={innerRef} display={["none", "block"]} my={2} bg={theme === "Dark" ? "brand.beige.dark" : "white"}>
      <Container as="section" w="868px" py={2} textAlign={textAlign}>
        <Text size="sm" color="text.secondary">
          {body}
        </Text>
      </Container>
    </Box>
  )
}
export default Summary
